module.exports = __webpack_public_path__ + "img/charticon.11788f9a.png";